module.exports = __webpack_public_path__ + "img/three-dots.047f53de.svg";